"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMeetingsLinks = fetchMeetingsLinks;
exports.fetchMeetingsUser = fetchMeetingsUser;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var MEETINGS_BASE_URL = 'meetings/v1';
var meetingsUserUrl = MEETINGS_BASE_URL + "/user";
var meetingsLinksUrl = MEETINGS_BASE_URL + "/link";

function fetchMeetingsLinks() {
  return (0, _ImmutableAPI.get)(meetingsLinksUrl);
}

function fetchMeetingsUser() {
  return (0, _ImmutableAPI.get)(meetingsUserUrl);
}